import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const createPackage = createAction(ACTION.CREATE_PACKAGE.REQUEST, (id, package_code) => ({id, package_code}));
export const removePackage = createAction(ACTION.DELETE_PACKAGE.REQUEST, (id, package_code) => ({id, package_code}));
export const beginRemovePackage = createAction(ACTION.BEGIN_DELETE_PACKAGE, id => ({id}));
